import { DATE_RANGE_PRESETS, DateRangePreset } from '../../../constants/dateRangePreset';
import { TabOption } from '../types/TabsConfig';

const dateRangePresetOrder: DateRangePreset[] = [
  DATE_RANGE_PRESETS['7D'],
  DATE_RANGE_PRESETS['4W'],
  DATE_RANGE_PRESETS['3M'],
  DATE_RANGE_PRESETS['1Y'],
  DATE_RANGE_PRESETS.YTD,
];

export const dateRangePresetOptions: TabOption<DateRangePreset>[] =
  dateRangePresetOrder.map((preset) => ({
    label: preset,
    value: preset,
  }));
